import React from 'react';
import { useNavigate } from 'react-router-dom';
import he from 'he';
import './Message.css';

const Message = ({ message, currentUserId, onUpvote }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    // Show relative time for recent messages
    if (diffMins < 1) {
      return 'Just now';
    } else if (diffMins < 60) {
      return `${diffMins} ${diffMins === 1 ? 'minute' : 'minutes'} ago`;
    } else if (diffHours < 24) {
      return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    } else if (diffDays < 7) {
      return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
    } else {
      // For older messages, show date
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
  };

  const handleUsernameClick = (e) => {
    e.preventDefault();
    // Try to get user_id from message, or fetch it if not available
    if (message.user_id) {
      navigate(`/user/${message.user_id}`);
    } else {
      // Fallback: could fetch user by username, but for now just show alert
      alert('User ID not available. Profile feature requires user_id.');
    }
  };

  return (
    <div className="message win98-bevel">
      <div className="message-header">
        <span 
          className="message-username clickable" 
          onClick={handleUsernameClick}
          title="View profile"
        >
          {message.username}
        </span>
        <span className="message-time">{formatDate(message.created_at)}</span>
      </div>
      <div className="message-content">
        {he.encode(message.content)}
      </div>
      <div className="message-footer">
        <button
          onClick={() => onUpvote(message.id)}
          className="win98-button upvote-button"
          title="Upvote this message!"
        >
          ⬆️ Upvote ({message.upvote_count || 0})
        </button>
        <span className="message-tx">
          💰 TX: {message.payment_tx_id?.substring(0, 16)}...
        </span>
      </div>
    </div>
  );
};

export default Message;

